module.exports = __webpack_public_path__ + "img/Kindness-on@3x.f65f44b7.png";